import { Box, Card, CardContent, CardMedia, Typography } from "@mui/material";
import IbssSvgIcon from '../../Icons/SvgIcon/IbssSvgIcon';
import MapPinIcon from '../../Icons/MapPinIcon';
import { IbssComponent } from '../../Core/BaseComponent/IbssComponent';
import FloorIcon from '../../Icons/FlooorIcon';
import ZoneIcon from '../../Icons/ZoneIcon';
import LinkIcon from '../../Icons/LinkIcon';
import { Constants } from '../../../Common/Constants';


export default class IbssEventDetail extends IbssComponent<IProps,IState>
{

    public render(): JSX.Element 
    {
        return (
            <Card sx={{ mt: 2 }}>
                <CardMedia
                    sx={{ height: 140 }}
                    image={this.props.spaceImage ? this.props.spaceImage :  Constants.imagePaths.get(this.props.spaceType)}
                    title={this.props.spaceType}
                />
                <CardContent>
                    <Box display={'flex'} gap={2} flexWrap={'wrap'} mb={2}>
                        <Box display="flex" alignItems="center">
                            <IbssSvgIcon sx={{ fontSize: 14 }}>
                                <MapPinIcon />
                            </IbssSvgIcon>
                            <Typography variant="body2" ml={1}>
                                {this.props.spaceName}
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center">
                            <IbssSvgIcon sx={{ fontSize: 14 }}>
                                <FloorIcon />
                            </IbssSvgIcon>
                            <Typography variant="body2"  ml={1}>
                                {this.props.floorName}
                            </Typography>
                        </Box>
                        <Box display="flex" alignItems="center">
                            <IbssSvgIcon sx={{ fontSize: 14 }}>
                                <ZoneIcon />
                            </IbssSvgIcon>
                            <Typography variant="body2" ml={1}>
                                {this.props.zoneName}
                            </Typography>
                        </Box>
                       {this.props.linkedSpaceNames.length > 0 && (<Box display="flex" alignItems="center">
                            <IbssSvgIcon sx={{ fontSize: 14 }}>
                                <LinkIcon />
                            </IbssSvgIcon>
                            <Typography variant="body2" ml={1}>
                            {this.props.linkedSpaceNames.join(', ')}
                            </Typography>
                        </Box> )}
                    </Box>
                </CardContent>
            </Card>
        )
    }
}

interface IState 
{
}

interface IProps 
{
    spaceImage: string;
    spaceType: string;
    spaceName: string;
    floorName: string;
    zoneName: string;
    linkedSpaceNames: string[];
}
